export default {
    header: {
        telefone: "電話番号",
        signIn: "ログイン",
        register: "登録",
        becomeExpert: "あなたの会社を登録",
        dashboard: "ダッシュボード",

        sidebar: {
            tuktuk: {
                title: "トゥクトゥク",
                subtitle: "トゥクトゥク予約",
                menu: {
                    grid: "トゥクトゥク一覧",
                },
            },
            about: {
                title: "アバウト",
                subtitle: "アバウト",
                menu: {
                    aboutUs: "私たちについて",
                    testimonials: "お客様の声",
                    faq: "よくある質問",
                    contact: "お問い合わせ",
                    terms: "利用規約",
                    privacy: "プライバシーポリシー",
                },
            },
            dashboard: {
                title: "ダッシュボード",
                subtitle: "ユーザーダッシュボード",
                subtitle2: "代理店ダッシュボード",
                menu: {
                    dashboard: "ダッシュボード",
                    myBookings: "マイ予約",
                    reviews: "レビュー",
                    support: "サポート",
                    wishlist: "ウィッシュリスト",
                    wallet: "ウォレット",
                    profileSettings: "プロフィール設定",
                    notifications: "通知",
                    myProfile: "マイプロフィール",
                    settings: "設定",
                    dashboard2: "ダッシュボード",
                    bookings: "予約",
                    enquiries: "お問い合わせ",
                    earnings: "収益",
                    reviews2: "レビュー",
                    settings2: "設定",
                },
            },
            social: {
                title: "ソーシャルネットワーク",
                subtitle: "投稿フィード",
                menu: {
                    feed: "フィード",
                    myProfilePage: "マイプロフィールページ",
                    explore: "探検する",
                },
            },
        },
    },

    common: {
        welcome: "ようこそ、{{name}} さん！",
    },

    home: {
        hero: {
            title: "夢に近づこう：",
            title2: "旅の必需品があなたを待っています",
            title3: "あなたへ",
            subtitle: "旅行体験を祝福し、記憶に残すための究極の目的地。",
            tukTuk: "トゥクトゥク",
        },
        searchBy: {
            titlePrefix: "パッケージ",
            titleSuffix: "最新",
            subtitle:
                "Portugalwaytour に最近追加されたパッケージを発見し、選りすぐりのユニークな旅行機会を探索し、忘れられない体験、新しい目的地、世界中の限定アドベンチャーを提供します。",
            noPackages: "最近のパッケージは見つかりませんでした。",
            hasDiferencial: "特別な特徴あり",
            noReviews: "レビューなし",
            viewAll: "すべてのパッケージを見る",
        },
        sectionBenefit: {
            titlePrefix: "私たちの",
            titleHighlight: "メリット",
            titleSuffix: "そして主な利点",
            subtitle:
                "Portugalway は夢の目的地を専門とするツアーオペレーターであり、旅行者にさまざまなメリットを提供しています。",
            benefits: [
                {
                    title: "本物の体験",
                    description:
                        "従来の観光から離れて、本物のポルトガルを発見しましょう！私たちのツアーは、地元の文化、料理、隠れたスポットを探検する真の体験を提供します。",
                },
                {
                    title: "パーソナライズされた旅行パッケージ",
                    description:
                        "あなただけの旅を作りましょう！体験を選び、宿泊、交通、アクティビティまで私たちがすべてお手伝いします：パーソナライズされた忘れられない旅へ。",
                },
                {
                    title: "快適さと安全性",
                    description:
                        "すべての詳細に配慮しています：快適な交通、厳選された宿泊施設、プロのガイドサポート、出発から到着まで安心を保証します。",
                },
                {
                    title: "専任サポート",
                    description:
                        "最初の問い合わせから旅の終わりまで、ポルトガル語と英語で、迅速かつ丁寧にサポートするチームがあなたを待っています。",
                },
            ],
        },
        exploreCities: {
            title: "都市別に探検する",
            subtitle: "素晴らしい目的地でユニークな体験を発見",
        },
        placeSection: {
            titlePrefix: "トレンド",
            titleHighlight: "パッケージ",
            subtitle:
                "旅行者に高く評価され、レビューが多く、予約の多い、最も人気のある旅行パッケージを厳選してご紹介します。次の忘れられない冒険をここで見つけましょう。",
            all: "すべて",
            hasDiferencial: "特別な特徴あり",
            noReviews: "レビューなし",
            viewAll: "すべてのパッケージを見る",
        },
        aboutSection: {
            welcome: "Portugalwaytour へようこそ",
            title: "地平線の先へ：世界の驚異を発見しよう",
            description1:
                "Portugal Way Tour では、旅こそが変革だと信じています。私たちはポルトガルでユニークな観光体験を専門とするエージェンシーであり、その文化、景観、歴史、そして本物らしさを明らかにすることに努めています。",
            point1:
                "記憶に残る旅を、快適さ、安全、魅力をもって提供します。旅行者一人ひとりが、伝統、自然、美食、本物のホスピタリティをミックスした旅を深く発見できるようにしたいと考えています。",
            point2:
                "ポルトガル観光における品質と信頼のリファレンスとなり、世界中の旅行者にプロフェッショナリズムと感動の代名詞として認められることを目指しています。",
            learnMore: "もっと見る",
            reviews: "{{count}}+ レビュー",
        },
        aboutCounters: [
            { label: "世界中の目的地", icon: "isax-global5", colorClass: "text-teal" },
            { label: "予約完了数", icon: "isax-calendar-2", colorClass: "text-purple" },
            { label: "世界のお客様数", icon: "isax-tag-user5", colorClass: "text-pink" },
            { label: "登録済み提供者数", icon: "isax-status-up5", colorClass: "text-info" },
        ],
        expertSection: {
            popularTitle: "人気",
            popularSubtitle:
                "旅行者によく予約され、高評価されているサービスを発見しましょう。",
            serviceName: "トゥクトゥクドライバー",
            loading: "読み込み中…",
            reservationsSingular: "予約",
            reservationsPlural: "予約件数",
            viewProfile: "プロフィールを見る",
            viewAll: "すべてを見る",
        },
        driverModal: {
            loading: "読み込み中…",
            description: "説明",
            languages: "言語",
            vehicle: "車両",
            seats: "座席",
            averageRating: "平均評価",
            reviews: "レビュー",
            packages: "パッケージ",
            noReviews: "まだレビューがありません",
            noPackages: "このドライバーはパッケージを持っていません",
        },
        testimonialSection: {
            title: "私たちの{{highlight}}が語ること",
            highlight: "ユーザー",
            subtitle: "旅行者の体験をチェックしましょう。",
            loading: "レビュー読み込み中…",
            noReviews: "レビューは見つかりませんでした。",
            noComment: "ユーザーがコメントを残していません。",
            viewPackage: "パッケージの詳細を見る",
        },
        updateSection: {
            faq: {
                title: "よくある質問{{highlight}}",
                highlight: "「よくある」",
                subtitle:
                    "Portugalwayは夢の目的地を専門とするツアーオペレーターであり、旅行者にさまざまなメリットを提供しています。",
                questions: [
                    {
                        question: "ツアーの予約はどうすればいいですか？",
                        answer:
                            "ウェブサイトから直接予約するか、メールまたは電話でお問い合わせください。希望の旅程を決定後、見積もりを提供し、ホテルとサービスを確認し、規定に従ってお支払いをお願いしています。",
                    },
                    {
                        question: "旅程のカスタマイズは可能ですか？",
                        answer:
                            "はい！すべての旅程は柔軟です。行きたい場所、滞在日数、宿泊タイプを選び、お客様のプロフィールに合った旅を私たちが作り上げます。",
                    },
                    {
                        question: "ガイドの言語は何ですか？",
                        answer:
                            "私たちはポルトガル語、英語、そしてツアーによっては他の言語を話すガイドを揃えています。予約時にご希望をお知らせください。",
                    },
                    {
                        question: "キャンセルポリシーはどうなっていますか？",
                        answer:
                            "キャンセルポリシーはツアー、予約時期、提供業者によって異なります。予約時に全条件を提供しています。確認してからご予約ください。",
                    },
                    {
                        question: "どの支払い方法が利用できますか？",
                        answer:
                            "国際銀行振込、クレジットカード、場合によりその他の支払い方法を受け付けています。",
                    },
                ],
                contactUsText:
                    "よくある質問で答えが見つからない場合は、お問い合わせください。近日中にご返信いたします！",
                contactButton: "お問い合わせ",
            },
            support: {
                items: [
                    "パーソナライズされた旅程",
                    "包括的なプランニング",
                    "専門家のガイダンス",
                    "ローカル体験",
                    "カスタマーサポート",
                    "持続可能性への取り組み",
                    "複数地域",
                ],
            },
        },
    },
    footer: {
        pages: {
            title: "ページ",
            settings: "設定",
            profile: "プロフィール",
            social: "ソーシャルネットワーク",
        },
        company: {
            title: "会社",
            about: "私たちについて",
            testimonials: "お客様の声",
            faq: "よくある質問",
        },
        support: {
            title: "サポート",
            contact: "お問い合わせ",
            privacy: "プライバシーポリシー",
            terms: "利用規約",
            chat: "チャットサポート",
        },
        services: {
            title: "サービス",
            tuktuk: "トゥクトゥク",
            winery: "ワイナリー",
            restaurant: "レストラン",
            car: "車",
            hippotrip: "ヒッポトリップ",
            bike: "自転車",
        },
        bottom: {
            copyright: "Copyright © 2025. 全著作権所有,",
            brand: "Portugalwaytour",
            social: [
                { icon: "fa-brands fa-facebook", link: "#" },
                { icon: "fa-brands fa-x-twitter", link: "#" },
                { icon: "fa-brands fa-instagram", link: "#" },
                { icon: "fa-brands fa-linkedin", link: "#" },
                { icon: "fa-brands fa-pinterest", link: "#" },
            ],
            cards: [
                "assets/img/icons/card-01.svg",
                "assets/img/icons/card-02.svg",
                "assets/img/icons/card-03.svg",
                "assets/img/icons/card-04.svg",
                "assets/img/icons/card-05.svg",
                "assets/img/icons/card-06.svg",
            ],
        },
    },

    auth: {
        registerModal: {
            title: "アカウントにアクセス",
            subtitle: "ログインまたはアカウント作成のためにメールを入力してください",
            emailLabel: "メール",
            emailPlaceholder: "メールを入力してください",
            sendTestCode: "テストコードを送信",
            sendEmailCode: "確認コードをメールで送信",
            codeLabel: "確認コード",
            codePlaceholder: "コードを入力",
            verifyAndLogin: "確認してログイン",
            testCodeSuccess: "テストコード「123456」が生成されました。ログインに使用してください。",
            testCodeError: "テストコードの生成中にエラーが発生しました。",
            emailSent: "確認コードをメールで送信しました！",
            emailError: "メール送信中にエラーが発生しました。",
            loginSuccess: "ログインに成功しました！",
            invalidCode: "コードが無効または期限切れです。",
            or: "または",
            google: "Google",
            facebook: "Facebook",
            reminderTitle: "プロフィールを完成させましょう",
            reminderText:
                "プラットフォームのすべての機能を利用するために、プロフィールの入力をお忘れなく！",
            gotIt: "了解しました",
        },
    },

    companyRegisterModal: {
        title: "会社登録",
        step1:
            "まず、個人のメールアドレスを入力して会社管理者アカウントを作成してください。このアカウントを使用して会社プロフィールを管理します。",
        step2:
            "確認コードをメールに送信しました。本人確認のため、以下にコードを入力してください。",
        step3:
            "次に会社情報を入力してください。会社のメールアドレスは法人用（例: info@empresa.com）である必要があります。",

        personalEmail: "個人メール",
        sendTestCode: "テストコードを送信",
        sendEmailCode: "確認コードをメールで送信",

        verificationCode: "確認コード",
        verifyCode: "コードを確認",

        companyEmail: "会社メール",
        companyName: "会社名",
        nif: "NIF",
        nib: "NIB",
        permanentCertificate: "永久証明書番号",
        phone: "電話番号",
        street: "住所",
        city: "市区町村",
        postalCode: "郵便番号",
        country: "国",
        companyDescription: "会社の簡単な説明",
        servicesProvided: "提供するサービス",

        contractTitle: "会社契約",
        acceptContract: "会社契約に同意します",
        finishRegistration: "登録を完了する",

        messages: {
            "Test code sent successfully. Use '123456'.":
                "テストコードが正常に送信されました。「123456」を使用してください。",
            "Verification email sent successfully.": "確認メールが正常に送信されました。",
            "Verification successful.": "確認が正常に完了しました。",
            "Company registered and contract accepted successfully!":
                "会社が正常に登録され、契約が承認されました！",
            testStepMessage:
                "テストコードが正常に送信されました。「123456」を使用してください。",
            emailStepMessage: "確認コードをメールに送信しました。以下に入力してください。",
        },

        errors: {
            "Failed to send the verification code.": "確認コードの送信に失敗しました。",
            "Invalid or expired code.": "コードが無効または期限切れです。",
            "Please fill all required fields.": "すべての必須項目を入力してください。",
            "You must accept the contract to register the company.":
                "会社を登録するには契約に同意する必要があります。",
            "You must be logged in to register the company.":
                "会社を登録するにはログインが必要です。",
            "Failed to register the company or accept the contract.":
                "会社の登録または契約承認に失敗しました。",
        },
    },

    chooseUsSection: {
        title: "なぜ私たちを選ぶのか？",
        cards: [
            {
                title: "利便性",
                description:
                    "1つのプラットフォームから旅行全体を計画し、時間と労力を節約します。複数のサイトを行き来する必要はありません。",
            },
            {
                title: "最良価格保証",
                description:
                    "信頼できる旅行パートナーと提携し、フライト、ホテル、レンタカーのいずれでも最高の料金を提供します。",
            },
            {
                title: "カスタマーサポート",
                description:
                    "24時間年中無休のサポートチームが、旅行の最初から最後までスムーズに進行するようお手伝いします。",
            },
            {
                title: "パーソナライズされた旅行体験",
                description:
                    "出張、家族旅行、ソロアドベンチャーなど、あらゆるニーズに対応したオプションを提供します。",
            },
        ],
    },

    contactUsSection: {
        breadcrumb: {
            home: "ホーム",
            pages: "ページ",
            contactUs: "お問い合わせ",
        },
        title: "専任サポートチームにご連絡ください",
        description: "私たちのチームがサポートいたします。お客様の満足が最優先です。",
        info: [
            {
                label: "メールアドレス",
                value: "portugaltourway@gmail.com",
            },
            {
                label: "電話番号",
                value: "INSERT NUMBER",
            },
            {
                label: "所在地",
                value: "INSERT RUA , Almada - Portugal",
            },
        ],
        supportCard: {
            title: "サポートが必要ですか？",
            textLoggedOut:
                "サポートチームに連絡してチケットを作成するには、アカウントを作成またはログインする必要があります。その後、サポートダッシュボードでリクエストを管理できます。",
            textLoggedIn:
                "すでにログインしています！ダッシュボードから新しいサポートチケットを作成または既存のチケットを確認できます。",
            btnLoggedOut: "アカウントを作成 / ログイン",
            btnLoggedIn: "ダッシュボードでチケットを開く",
        },
    },

    sidebar: {
        main: "メイン",
        dashboard: "ダッシュボード",
        myBookings: "マイ予約",
        myReviews: "レビュー",
        wishlist: "ウィッシュリスト",
        support: "サポート",
        finance: "財務",
        wallet: "ウォレット",
        payments: "支払い",
        account: "アカウント",
        myProfile: "マイプロフィール",
        notifications: "通知",
        settings: "設定",
        preferences: "設定",
        logout: "ログアウト",
    },

    agentSidebar: {
        dashboard: "ダッシュボード",
        bookings: "予約",
        tukTukBookings: "トゥクトゥク予約",
        hotelBookings: "ホテル予約",
        carBookings: "車予約",
        cruiseBookings: "クルーズ予約",
        tourBookings: "ツアー予約",
        flightBookings: "フライト予約",
        enquiries: "お問い合わせ",
        earnings: "収益",
        reviews: "レビュー",
        support: "サポート",
        serviceEnrollment: "サービス登録",
        drivers: "ドライバー",
        tukTukVehicles: "トゥクトゥク車両",
        settings: "設定",
        logout: "ログアウト",
    },

    dashboardCards: {
        totalBookings: "購入済みパッケージ合計",
        totalListings: "登録パッケージ合計",
        totalEarnings: "総収益",
        totalReviews: "レビュー合計",
    },

    recentlyadded: {
        titulo: "最近追加された",
    },

    BookingsStatistics: {
        titulo: "予約統計",
        loading: "統計を読み込み中...",
        none: "まだ予約が登録されていません。",
    },
};
